import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
  ElementRef,
  inject,
  AfterViewInit,
  // signal,
  contentChildren,
  AfterContentInit,
  OnDestroy,
} from '@angular/core';
import { WidgetGroupLayoutConfig } from '../../../../interfaces/view-widget';
// import { ViewportAwareDirective } from '../../directives/viewport-aware.directive';
import { Stylable } from '../../../../directives/stylable';

@Component({
  selector: 'ol-widgets-group',
  templateUrl: './widgets-group.component.html',
  styleUrls: ['./widgets-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // imports: [ViewportAwareDirective],
})
export class WidgetsGroupComponent extends Stylable implements AfterViewInit, AfterContentInit, OnDestroy {
  private hostElement = inject(ElementRef<HTMLElement>);

  layoutConfig = input<WidgetGroupLayoutConfig>({
    gap: 12,
  });

  // Get all widget elements from content projection
  widgetElements = contentChildren(ElementRef, { descendants: true });

  // Get total widget count
  totalWidgetCount = computed(() => this.widgetElements().length);

  // private itemHeight = signal<number>(0);

  containerStyles = computed(() => {
    const config = this.layoutConfig();
    return {
      display: 'flex',
      'flex-direction': 'column',
      gap: `${config.gap}px`,
    };
  });

  ngAfterViewInit(): void {
    // this.measureItemHeight();
  }

  // private updateStickyBehavior(): void {
  //   const elements = this.getWidgetElements();
  //   const totalElements = elements.length;
  //
  //   if (totalElements === 0) return;
  //
  //   elements.forEach((element) => {
  //     element.style.position = '';
  //     element.style.top = '';
  //     element.style.zIndex = '';
  //   });
  //
  //   if (totalElements > 1) {
  //     const lastElement = elements[totalElements - 1];
  //
  //     lastElement.style.position = 'sticky';
  //     lastElement.style.top = '80px';
  //     lastElement.style.zIndex = '10';
  //
  //     setTimeout(() => {
  //       const rect = lastElement.getBoundingClientRect();
  //       console.log('Element position after sticky:', {
  //         top: rect.top,
  //         bottom: rect.bottom,
  //         height: rect.height,
  //       });
  //     }, 1000);
  //
  //     let parent = lastElement.parentElement;
  //     while (parent && parent !== document.body) {
  //       parent = parent.parentElement;
  //     }
  //   }
  // }

  private getWidgetElements(): HTMLElement[] {
    const contentElements = this.widgetElements();

    if (contentElements.length > 0) {
      return contentElements.map(ref => ref.nativeElement);
    }

    // Fallback to direct DOM query
    return Array.from(this.hostElement.nativeElement.querySelectorAll('.widgets-group > *')) as HTMLElement[];
  }

  // private measureItemHeight(): void {
  //   const firstItem =
  //     this.hostElement.nativeElement.querySelector('.widgets-group > *');
  //   if (firstItem) {
  //     const height = firstItem.getBoundingClientRect().height;
  //     this.itemHeight.set(height || 190);
  //   } else {
  //     this.itemHeight.set(190);
  //   }
  // }

  ngAfterContentInit(): void {
    // Setup sticky behavior after content is projected
    // setTimeout(() => {
    //   this.updateStickyBehavior();
    // }, 0);
  }

  ngOnDestroy(): void {
    // Clean up any inline styles if needed
    const elements = this.getWidgetElements();
    elements.forEach(element => {
      element.style.position = '';
      element.style.top = '';
      element.style.zIndex = '';
    });
  }
}
